import { format } from "date-fns";
import { fromPromise, log, setup } from "xstate";

import { tauriApi } from "~/state/api/tauri";

export const initRepoMachine = setup({
	types: {
		context: {} as {
			path: string;
		},
		input: {} as {
			path: string;
		},
	},
	actors: {
		gitInit: fromPromise<void, { path: string }>(async ({ input }) => {
			await tauriApi.init(input);
		}),
		gitCommit: fromPromise<void, { path: string }>(async ({ input }) => {
			const prettyTimestamp = format(new Date(), "PPppp");

			await tauriApi.commit({ ...input, message: `🚀 Initial commit at ${prettyTimestamp}` });
		}),
	},
}).createMachine({
	id: "init-repo",
	initial: "initializing",
	context: ({ input }) => ({
		path: input.path,
	}),
	states: {
		initializing: {
			invoke: {
				src: "gitInit",
				input: ({ context }) => ({ path: context.path }),
				onError: {
					actions: log("Failed to initialize git repository (this may be expected)"),
					// Ignore errors, generally this will only error if the repo is already initialized and in that case we can just move on. There are code paths where this is expected.
					target: "creatingFirstCommit",
				},
				onDone: {
					target: "creatingFirstCommit",
				},
			},
		},
		creatingFirstCommit: {
			invoke: {
				src: "gitCommit",
				input: ({ context }) => ({ path: context.path }),
				onError: {
					actions: ({ event }) => {
						throw new Error("Failed to create first commit", { cause: event.error });
					},
					target: "done",
				},
				onDone: {
					target: "done",
				},
			},
		},
		done: {
			type: "final",
		},
	},
});
